export const explainAccess = /* GraphQL */ `
  query explainAccess($input: ExplainAccessInput!) {
  explainAccess(input: $input) {
      bindingPath
      hasAccess
      reason
      roles
  }
}
`;

export const getRole = /* GraphQL */ `
  query getRole($id: ID!) {
  getRole(id: $id) {
      createdAt
      createdBy
      description
      displayName
      id
      includeFutureConfig
      key
      ownerId
      updatedAt
      updatedBy
      workspaceId
  }
}
`;

export const listMcpAccessTokens = /* GraphQL */ `
  query listMcpAccessTokens {
  listMcpAccessTokens {
      createdAt
      expiresAt
      id
      lastUsedAt
      name
      revokedAt
  }
}
`;

export const listRolePermissions = /* GraphQL */ `
  query listRolePermissions($limit: Int, $nextToken: String) {
  listRolePermissions(limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        createdBy
        id
        objectId
        objectType
        ownerId
        roleId
        workspaceId
      }
      nextToken
  }
}
`;

export const listRoles = /* GraphQL */ `
  query listRoles($limit: Int, $nextToken: String) {
  listRoles(limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        createdBy
        description
        displayName
        id
        includeFutureConfig
        key
        ownerId
        updatedAt
        updatedBy
        workspaceId
      }
      nextToken
  }
}
`;

export const listUserRoles = /* GraphQL */ `
  query listUserRoles($limit: Int, $nextToken: String) {
  listUserRoles(limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        createdBy
        id
        ownerId
        roleId
        userId
        workspaceId
      }
      nextToken
  }
}
`;
